import React, { useRef } from "react";
import { extractFileId } from "../../../../../../utils/data";
import Uploader from "../uploader";
import check from "../../../../../../assets/images/svgs/check.svg";
import checkRound from "../../../../../../assets/images/svgs/checkRound.svg";
import { getAssessmentData } from "../../../../../../functions/localStorage";
import {
  removeImage,
  uploadImageApi,
} from "../../../../../../api/apis/assesments";
import { parseIfStringify } from "../../../../../../functions/common";

const SingleChoice = ({
  data,
  handleAnswer,
  answers,
  setUploadLoading,
  uploadLoading,
  currentIndex
}) => {
  const answersArray = Object.entries(data?.answers || {})
    .map(([key, value]) => ({
      key,
      value,
    }))
    ?.filter((v) => v?.value);
  const splittesAnswer = answers?.[data?.refCode]?.split(" + ");
  const selectedOption = splittesAnswer?.[0] ?? "";
  const inputRef = useRef();
  const { locationId, assessmentId } = getAssessmentData() ?? {};
  const images = parseIfStringify(splittesAnswer?.[1] ?? []);

  const handleOptionSelect = (value) => {
    handleAnswer(`${value} + ${JSON.stringify(images)}`);
  };

  const handleDelete = (item) => {
    const driveId = extractFileId(item?.viewLink);
    const updatedImages = images?.filter((v) => v?.viewLink !== item?.viewLink);
    handleAnswer(`${selectedOption} + ${JSON.stringify(updatedImages)}`);
    if (driveId) removeImage(driveId);
  };

  const handleFileUpload = async (file) => {
    if (file) {
      setUploadLoading(true);
      const imageData = await uploadImageApi(
        {
          file: file,
          ref: data?.refCode,
        },
        locationId,
        assessmentId
      );
      setUploadLoading(false);
      const fileData = {
        fileName: imageData?.data?.fileName,
        viewLink: imageData?.data?.viewLink,
      };
      const updatedImages = [...images, fileData];
      const formattedAnswer = `${selectedOption} + ${JSON.stringify(
        updatedImages
      )}`;
      handleAnswer(formattedAnswer);
      inputRef.current.value = "";
    }
  };
  return (
    <div className="options">
      <div className="single__choice">
        {answersArray?.map((v, i) => {
          return (
            <button onClick={() => handleOptionSelect(v?.value)} key={i}>
              <div>
                <img
                  src={selectedOption === v?.value ? check : checkRound}
                  className="check__box"
                  alt="check_box"
                />
              </div>
              <div>{v?.value}</div>
            </button>
          );
        })}
      </div>
      {data?.supportingDoc && (
        <Uploader
          images={images}
          inputRef={inputRef}
          handleFileUpload={handleFileUpload}
          handleUpload={handleFileUpload}
          handleDelete={handleDelete}
          uploadLoading={uploadLoading}
          data={data}
          currentIndex={currentIndex}
        />
      )}
    </div>
  );
};

export default SingleChoice;
